import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbles: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBubbles"><Path d="M2.50195 7.5H17.502V18.5H10.502L6.00195 21V18.5H2.50195V7.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M17.4998 14.5H21.502V3.5H6.75195V7.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBubbles;
